import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList([
        { url: _ctx.instagramURL, icon: _ctx.InstagramIcon },
        { url: _ctx.twitterURL, icon: _ctx.TwitterIcon },
        { url: _ctx.facebookURL, icon: _ctx.FacebookIcon },
      ], (link) => {
      return (_openBlock(), _createBlock("a", {
        key: link.url,
        href: link.url,
        target: "_blank",
        rel: "noopener noreferrer",
        class: "lg:transform lg:hover:scale-150 transition-transform",
        style: {"padding":"0 0.75em"}
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(link.icon), {
          fill: "currentColor",
          class: "w-9 md:w-4"
        }))
      ], 8, ["href"]))
    }), 128))
  ]))
}